import ApiService from "service/Api";
import { GeneralSettingPayloadTypes } from "utilities/types/GeneralSetting";

const GeneralSettingService = {
  getAllGeneralSettings: async (
    page: number,
    search: string,
    limit: number,
    filterCategory: string,
    filterTenant: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_category: filterCategory,
        filter_tenant: filterTenant,
      },
      url: "/admin/general-settings",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeGeneralSetting: async (payload: GeneralSettingPayloadTypes) => {
    const { name, value, category, description, tenantId } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        name: name,
        value: value,
        category: category,
        description: description,
        tenant_id: tenantId,
      },
      url: "/admin/general-settings",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateGeneralSetting: async (
    generalSettingId: string,
    payload: GeneralSettingPayloadTypes
  ) => {
    const { name, value, category, description, tenantId } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        name: name,
        value: value,
        category: category,
        description: description,
        tenant_id: tenantId,
        _method: "PUT",
      },
      url: "/admin/general-settings/" + generalSettingId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteGeneralSetting: async (generalSettingId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/general-settings/" + generalSettingId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getAllGeneralSettingCategories: async () => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/general-settings-categories",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default GeneralSettingService;
